module.exports = "/_next/static/images/6e9f1edec7e2b66b7c481f4f1d6fd755-celebrate.jpg.webp";